import { useState } from "react";
import { useCompaniesFilter } from "@/contexts/CompaniesFilterContext";
import { CompaniesGrid } from "@/components/companies/CompaniesGrid";
import { CompaniesList } from "@/components/companies/CompaniesList";
import { CandidatesViewOptions, SortField } from "@/components/candidates/CandidatesViewOptions";
import { CandidatesPagination } from "@/components/candidates/CandidatesPagination";
import { useCompaniesFiltering } from "@/hooks/companies/useCompaniesFiltering";
import { Company } from "@/components/CompanyCard";
import { useTranslation } from "react-i18next";

interface CompaniesContentProps {
  companies: Company[];
  isLoading: boolean;
}

export const CompaniesContent = ({
  companies,
  isLoading
}: CompaniesContentProps) => {
  const {
    searchTerm,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    viewMode,
    setViewMode,
    currentPage,
    setCurrentPage
  } = useCompaniesFilter();

  const { paginatedCompanies, totalPages } = useCompaniesFiltering(
    companies,
    searchTerm,
    sortField,
    sortOrder,
    currentPage
  );

  const { t } = useTranslation();

  // Reset to first page when sort field or order changes
  const handleSortFieldChange = (field: SortField) => {
    setSortField(field);
    setCurrentPage(1);
  };

  return (
    <div>
      <CandidatesViewOptions 
        sortField={sortField}
        setSortField={handleSortFieldChange}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      
      {viewMode === "card" ? (
        <CompaniesGrid 
          companies={companies}
          filteredCompanies={paginatedCompanies}
          isLoading={isLoading}
        />
      ) : (
        <CompaniesList 
          companies={companies}
          filteredCompanies={paginatedCompanies}
          isLoading={isLoading}
        />
      )}
      
      {totalPages > 1 && (
        <CandidatesPagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};
